import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../i18n/LocaleProvider';

/**
 * Language picker. A native select, so it keeps working as more packs are
 * registered and needs no change when a language is added.
 */
export const LanguageSwitcher: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const { language, languages, setLanguage } = useLocale();

  return (
    <select
      value={language}
      aria-label={t('language.label')}
      title={t('language.label')}
      className={className}
      onChange={(e) => {
        void setLanguage(e.target.value);
      }}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.nativeName}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
